import { styled } from "@styles";

export const Wrapper = styled.div``;

export const ReviewImage = styled.img`
  width: 540px;
  height: 540px;
  margin: .5rem;
  cursor: pointer;
`;
